import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const List = styled.ul`
  display: flex;
  align-items: center;
  width: 100%;

  margin: 0;
  padding: 0;

  list-style: none;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.spacing(2)};
`;

export const ListItem = styled.li`
  flex: 1;
  height: 4rem;
`;

export const DayButton = styled.button<{
  $isOccurrence: boolean;
  $completionPercentage: number;
  $isPerfect: boolean;
  $isSkipped: boolean;
  $isFailure: boolean;
  $isFuture: boolean;
}>`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;

  border: none;
  background: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.grey[400]};

  font-weight: ${({ theme }) => theme.typography.fontWeightBold};

  ${({ theme, $isOccurrence }) =>
    $isOccurrence &&
    css`
      color: ${theme.palette.text.primary};
    `};

  ${({ $isSkipped, theme }) =>
    $isSkipped &&
    css`
      background-color: ${theme.palette.warning.light};
      color: ${theme.palette.warning.main};
    `};

  ${({ $isFailure, theme }) =>
    $isFailure &&
    css`
      background-color: ${theme.palette.error.light};
      color: ${theme.palette.error.main};
    `};

  ${({ theme, $completionPercentage, $isPerfect }) =>
    $completionPercentage > 0 &&
    css`
      background: ${rgba(
        $isPerfect ? theme.palette.success.main : theme.palette.primary.main,
        0.2,
      )};
      color: ${$isPerfect
        ? theme.palette.success.contrastText
        : theme.palette.primary.contrastText};

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: ${Math.min(Math.max($completionPercentage, 0), 100)}%;
        width: 100%;

        background: ${$isPerfect
          ? theme.palette.success.main
          : theme.palette.primary.main};
      }
    `};

  ${({ $isFuture }) =>
    $isFuture &&
    css`
      opacity: 0.5;
    `};
`;

export const DayLabel = styled.span<{ $isIcon?: boolean }>`
  position: relative;
  line-height: 62.5%;

  ${({ $isIcon }) =>
    $isIcon &&
    css`
      font-size: 1.6rem;
      line-height: 62.5%;
    `}
`;

export const DayIcon = styled.span`
  position: relative;
  font-size: 1.6rem;
  line-height: 62.5%;
`;
